import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

export const useGetLightStudents = () => {
  const [students, setStudents] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const getStudents = async ({
    page = 1,
    per_page = 10,
    paginate = true,
    filters = {},
    sort = "",
  } = {}) => {
    try {
      setLoading(true);
      setError("");

      const query = new URLSearchParams();

      query.append("page", page);
      query.append("per_page", per_page);
      query.append("paginate", paginate);

      Object.keys(filters).forEach((field) => {
        if (filters[field] !== "" && filters[field] !== undefined) {
          query.append(`filter[${field}]`, filters[field]);
        }
      });

      if (sort) query.append("sort", sort);

      const url = `${TENANT_DOMAIN}/references/students?${query.toString()}`;

      const response = await axiosInstance.get(url);

      const data = response.data.data || [];
      const metaData = response.data.meta || null;

      setStudents(data);
      setMeta(metaData);

      /* ✅ IMPORTANT: return response */
      return {
        success: true,
        data,
        meta: metaData,
      };
    } catch (err) {
      setStudents(null);
      setMeta(null);

      const errorMessage =
        err?.response?.status === 500
          ? ERROR_MESSAGES.INTERNAL_SERVER
          : err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;

      setError(errorMessage);

      return {
        success: false,
        data: [],
        meta: null,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    students,
    meta,
    loading,
    error,
    getStudents,
  };
};
